import React, {useCallback, useContext} from 'react'
import {
    Route,
    Switch,
    Redirect, useHistory,
} from 'react-router-dom'
import Navbar from './elements/navbar'
import AdminAuthPage from './pages/adminauthpage'
import { AuthPage } from './pages/authpage'
import CarsPage from './pages/carsPage'
import ClientsPage from "./pages/clientsPage";
import OrdersPage from "./pages/ordersPage";
import AnalyticsPage from "./pages/analyticsPage";
import HelloPage from "./pages/helloPage";
import {Footer} from "./elements/footer";
import TelegramClientsPage from "./pages/telegramClientsPage";
import {AuthContext} from "./context/authcontext";
import {useSelector} from "react-redux";

export const useRoutes = (isAuthenticated) => {

    const invalidToken = useSelector(state => state.app.invalToken)

    const log = useCallback(async () => {
        if (invalidToken) {
            await localStorage.removeItem('userData')
            window.location.reload()
        }
    }, [invalidToken])
    log()


    if (isAuthenticated) {
        return (
            <>
                <Navbar />
                    <Switch>
                        <Route path="/addclient" exact>
                            <AuthPage />
                        </Route>
                        <Route path="/carslist" exact>
                            <CarsPage />
                        </Route>
                        <Route path="/clientslist" exact>
                            <ClientsPage />
                        </Route>
                        <Route path="/orders" exact>
                            <OrdersPage />
                        </Route>
                        <Route path="/analytics" exact>
                            <AnalyticsPage />
                        </Route>
                        <Route path="/telegramclients" exact>
                            <TelegramClientsPage />
                        </Route>
                        <Route path="/" exact>
                            <HelloPage />
                        </Route>
                        <Redirect to="/" />
                    </Switch>
                <Footer />
            </>
        )
    }

    return (
        <Switch>
            <Route path="/" exact>
                <AdminAuthPage />
            </Route>
            <Redirect to="/" />
        </Switch>
    )
}